import { useQuery } from '@apollo/client/react';
import { useDebounce } from 'use-debounce';
import { OrderByArg } from 'shared/domains/apollo/generated/types';
import { getAllMarketCodes, supportedMarketCodes } from 'shared/domains/markets/config';
import { GlobalSearchDocument } from './GlobalSearch.gql';
import { transformSearchQuery } from './transformSearchQuery';
import { useSearchContext } from '../../components/SearchProvider';
export function useSearchQuery(variables, options) {
    const { values, modifiers } = useSearchContext();
    const { query, filters, referrer, offset, limit, orderBy } = values;
    const { where } = variables || {};
    const userMarketCodes = getAllMarketCodes();
    const excludedMarketCodes = supportedMarketCodes.filter((item) => !userMarketCodes.includes(item));
    const [queryVariables] = useDebounce({
        query,
        where: Object.assign(Object.assign(Object.assign({}, filters), where), { marketCode: {
                notIn: excludedMarketCodes,
            } }),
        limit,
        referrer,
        offset,
        orderBy: Object.assign(Object.assign({}, orderBy), { updatedAt: OrderByArg.Desc }),
        modifiers,
    }, 350);
    const { data, loading, error } = useQuery(GlobalSearchDocument, {
        variables: queryVariables,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'cache-and-network',
        skip: options === null || options === void 0 ? void 0 : options.skip,
    });
    const transformQueryData = transformSearchQuery(data);
    return {
        data: transformQueryData,
        loading,
        error,
        query,
    };
}
